import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ItemsList } from "@parkschannel/ui";
import { useVideoModalContext, VideoCardWithTags } from "../../Video";
export const PopularVideoList = (param)=>{
    let { data  } = param;
    const { setSelectedVideo  } = useVideoModalContext();
    return /*#__PURE__*/ _jsx(ItemsList, {
        className: "w-full py-6 grid gap-4 md:gap-6 md:grid-cols-2 xl:grid-cols-3",
        items: data,
        noItemsMessage: "Videos not found",
        renderItem: (video)=>/*#__PURE__*/ _jsx(VideoCardWithTags, {
                thumbnailClassName: "h-[190px]",
                data: video,
                onClick: setSelectedVideo
            })
    });
};
